// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.about-mask {

    width: 100%;
    height: 450px;


}

.about-mask img {

    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: right 70%;

}

.about-mask::before {
    content: "";
    width: 100%;
    height: 450px;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #000000;
  mask:radial-gradient(circle at 20% 40%, transparent , #fff 50%);
    opacity: 0.8;
    z-index: 0;
}

.about-content {
    /* border: 1px solid red; */
    position: absolute;
    top:200px;
    left: 450px;
    width: 500px;
    height: auto;
    text-align: center;
   

}

.about-content h1,
h2,
h3,
h4,
h5,
h6,
p {
    color: rgb(255, 255, 255);
    
}
.about-content h1{
    /* border: 1px solid blue; */
    font-size: 60px;
    line-height: 70px;
    
}
.about-content p{
    /* border: 1px solid rgb(166, 255, 0); */
    font-weight: 300;
    font-size: 18px;
    
}











@media (max-width:1440px) {

    .about-mask {

        width: 100%;
        height: 450px;
    }
    .about-mask img {

        width: 100%;
        height:450px;
        object-fit: cover;
        object-position: right 70%;
     
    }
    .about-mask::before {

        height: 450px;
       
    }


    .about-content {
        /* border: 1px solid red; */
        position:absolute;
        left:0;
        right:0;
        margin-left:auto;
        margin-right:auto;
        top:200px;
        left: 40%;
        width: 500px;
        height: auto;
        text-align: center;  
    }
    
.about-content h1{
    /* border: 1px solid blue; */
    font-size: 60px;
    line-height: 70px;
    
}
.about-content p{
    /* border: 1px solid rgb(166, 255, 0); */
    font-weight: 300;
    font-size: 18px;
    
    
}






    /* .about-mask {

        width: 100%;
        height: 450px;
    
    
    }
    .about-content {
        left: 700px;
        width: 600px;
        height: auto; 
    }
    .about-mask img {
        width: 100%;
        height:450px;
        object-fit: cover;
        object-position: right 70%;
    } */
} 

/* Responsive For Tablet Screen size 767px to 1023px START */
@media (max-width:1023px) {

    .about-mask {

        width: 100%;
        height: 350px;
    }
    .about-mask img {

        width: 100%;
        height:350px;
        object-fit: cover;
        object-position: right 70%;
     
    }
    .about-mask::before {

        height: 350px;
       
    }


    .about-content {
        /* border: 1px solid red; */
        position:absolute;
        left:0;
        right:0;
        margin-left:auto;
        margin-right:auto;
        top:200px;
        left: 290px;
        width: 400px;
        height: auto;
        text-align: center;  
    }
    
.about-content h1{
    /* border: 1px solid blue; */
    font-size: 40px;
    line-height: 40px;
    
}
.about-content p{
    /* border: 1px solid rgb(166, 255, 0); */
    font-weight: 300;
    font-size: 14px;
    line-height: 16px;
    text-shadow: 2px 2px 5px rgb(0, 0, 0);
    
}

    }
    
    /* Responsive For Tablet Screen size 601px to 1023px END */
    
    
    
    
    
    /* Responsive For Mobile Screen size 1024px to 1920px START */
    @media (max-width:767px) {
    
        .about-mask {


            height: 250px;
        }
        .about-mask img {
    
         
            height:250px;
      
            object-position: left 90%;
         
        }
        .about-mask::before {
    
            height: 250px;
           
        }
        .about-content {
          
            top:150px;
            left: 0px;
            width: 270px;
  
        }
   
        .about-content h1{
            /* border: 1px solid blue; */
            font-size: 25px;
            line-height: 30px;
            
        }
        .about-content p{
            /* border: 1px solid rgb(166, 255, 0); */
     
            font-size: 12px;
            line-height: 18px;
           
            
        }
        


    }
    
    /* Responsive For Mobile Screen size 1024px to 1920px END */
    `, "",{"version":3,"sources":["webpack://./src/Components/AboutheroStyles.css"],"names":[],"mappings":";AACA;;IAEI,WAAW;IACX,aAAa;;;AAGjB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,0BAA0B;;AAE9B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,yBAAyB;EAG3B,+DAA+D;IAC7D,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;;;AAGtB;;AAEA;;;;;;;IAOI,yBAAyB;;AAE7B;AACA;IACI,4BAA4B;IAC5B,eAAe;IACf,iBAAiB;;AAErB;AACA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,eAAe;;AAEnB;;;;;;;;;;;;AAYA;;IAEI;;QAEI,WAAW;QACX,aAAa;IACjB;IACA;;QAEI,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,0BAA0B;;IAE9B;IACA;;QAEI,aAAa;;IAEjB;;;IAGA;QACI,2BAA2B;QAC3B,iBAAiB;QACjB,MAAM;QACN,OAAO;QACP,gBAAgB;QAChB,iBAAiB;QACjB,SAAS;QACT,SAAS;QACT,YAAY;QACZ,YAAY;QACZ,kBAAkB;IACtB;;AAEJ;IACI,4BAA4B;IAC5B,eAAe;IACf,iBAAiB;;AAErB;AACA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,eAAe;;;AAGnB;;;;;;;IAOI;;;;;;;;;;;;;;;;;OAiBG;AACP;;AAEA,4DAA4D;AAC5D;;IAEI;;QAEI,WAAW;QACX,aAAa;IACjB;IACA;;QAEI,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,0BAA0B;;IAE9B;IACA;;QAEI,aAAa;;IAEjB;;;IAGA;QACI,2BAA2B;QAC3B,iBAAiB;QACjB,MAAM;QACN,OAAO;QACP,gBAAgB;QAChB,iBAAiB;QACjB,SAAS;QACT,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,kBAAkB;IACtB;;AAEJ;IACI,4BAA4B;IAC5B,eAAe;IACf,iBAAiB;;AAErB;AACA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;AAEzC;;IAEI;;IAEA,0DAA0D;;;;;;IAM1D,6DAA6D;IAC7D;;QAEI;;;YAGI,aAAa;QACjB;QACA;;;YAGI,YAAY;;YAEZ,yBAAyB;;QAE7B;QACA;;YAEI,aAAa;;QAEjB;QACA;;YAEI,SAAS;YACT,SAAS;YACT,YAAY;;QAEhB;;QAEA;YACI,4BAA4B;YAC5B,eAAe;YACf,iBAAiB;;QAErB;QACA;YACI,wCAAwC;;YAExC,eAAe;YACf,iBAAiB;;;QAGrB;;;;IAIJ;;IAEA,2DAA2D","sourcesContent":["\n.about-mask {\n\n    width: 100%;\n    height: 450px;\n\n\n}\n\n.about-mask img {\n\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: right 70%;\n\n}\n\n.about-mask::before {\n    content: \"\";\n    width: 100%;\n    height: 450px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-color: #000000;\n\n  -webkit-mask:radial-gradient(circle at 20% 40%, transparent , #fff 50%);\n  mask:radial-gradient(circle at 20% 40%, transparent , #fff 50%);\n    opacity: 0.8;\n    z-index: 0;\n}\n\n.about-content {\n    /* border: 1px solid red; */\n    position: absolute;\n    top:200px;\n    left: 450px;\n    width: 500px;\n    height: auto;\n    text-align: center;\n   \n\n}\n\n.about-content h1,\nh2,\nh3,\nh4,\nh5,\nh6,\np {\n    color: rgb(255, 255, 255);\n    \n}\n.about-content h1{\n    /* border: 1px solid blue; */\n    font-size: 60px;\n    line-height: 70px;\n    \n}\n.about-content p{\n    /* border: 1px solid rgb(166, 255, 0); */\n    font-weight: 300;\n    font-size: 18px;\n    \n}\n\n\n\n\n\n\n\n\n\n\n\n@media (max-width:1440px) {\n\n    .about-mask {\n\n        width: 100%;\n        height: 450px;\n    }\n    .about-mask img {\n\n        width: 100%;\n        height:450px;\n        object-fit: cover;\n        object-position: right 70%;\n     \n    }\n    .about-mask::before {\n\n        height: 450px;\n       \n    }\n\n\n    .about-content {\n        /* border: 1px solid red; */\n        position:absolute;\n        left:0;\n        right:0;\n        margin-left:auto;\n        margin-right:auto;\n        top:200px;\n        left: 40%;\n        width: 500px;\n        height: auto;\n        text-align: center;  \n    }\n    \n.about-content h1{\n    /* border: 1px solid blue; */\n    font-size: 60px;\n    line-height: 70px;\n    \n}\n.about-content p{\n    /* border: 1px solid rgb(166, 255, 0); */\n    font-weight: 300;\n    font-size: 18px;\n    \n    \n}\n\n\n\n\n\n\n    /* .about-mask {\n\n        width: 100%;\n        height: 450px;\n    \n    \n    }\n    .about-content {\n        left: 700px;\n        width: 600px;\n        height: auto; \n    }\n    .about-mask img {\n        width: 100%;\n        height:450px;\n        object-fit: cover;\n        object-position: right 70%;\n    } */\n} \n\n/* Responsive For Tablet Screen size 767px to 1023px START */\n@media (max-width:1023px) {\n\n    .about-mask {\n\n        width: 100%;\n        height: 350px;\n    }\n    .about-mask img {\n\n        width: 100%;\n        height:350px;\n        object-fit: cover;\n        object-position: right 70%;\n     \n    }\n    .about-mask::before {\n\n        height: 350px;\n       \n    }\n\n\n    .about-content {\n        /* border: 1px solid red; */\n        position:absolute;\n        left:0;\n        right:0;\n        margin-left:auto;\n        margin-right:auto;\n        top:200px;\n        left: 290px;\n        width: 400px;\n        height: auto;\n        text-align: center;  \n    }\n    \n.about-content h1{\n    /* border: 1px solid blue; */\n    font-size: 40px;\n    line-height: 40px;\n    \n}\n.about-content p{\n    /* border: 1px solid rgb(166, 255, 0); */\n    font-weight: 300;\n    font-size: 14px;\n    line-height: 16px;\n    text-shadow: 2px 2px 5px rgb(0, 0, 0);\n    \n}\n\n    }\n    \n    /* Responsive For Tablet Screen size 601px to 1023px END */\n    \n    \n    \n    \n    \n    /* Responsive For Mobile Screen size 1024px to 1920px START */\n    @media (max-width:767px) {\n    \n        .about-mask {\n\n\n            height: 250px;\n        }\n        .about-mask img {\n    \n         \n            height:250px;\n      \n            object-position: left 90%;\n         \n        }\n        .about-mask::before {\n    \n            height: 250px;\n           \n        }\n        .about-content {\n          \n            top:150px;\n            left: 0px;\n            width: 270px;\n  \n        }\n   \n        .about-content h1{\n            /* border: 1px solid blue; */\n            font-size: 25px;\n            line-height: 30px;\n            \n        }\n        .about-content p{\n            /* border: 1px solid rgb(166, 255, 0); */\n     \n            font-size: 12px;\n            line-height: 18px;\n           \n            \n        }\n        \n\n\n    }\n    \n    /* Responsive For Mobile Screen size 1024px to 1920px END */\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
